import { useEffect, useState } from 'react';
import useMultiTokenData from './useMultiTokenData';
import { nativeTokens } from './useTokenSearch';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
export default function useGetNativeTokenData({
  enabled = true
} = {}) {
  const [nativeTokensData, setNativeTokensData] = useState([]);
  const {
    data: nativeTokensPreData,
    isLoading: nativeTokensDataLoading
  } = useMultiTokenData({
    tokens: nativeTokens.map(x => x.wrappedAddress + ':' + x.network),
    minMarketCap: 0,
    enabled
  });
  useEffect(() => {
    if ((nativeTokensPreData === null || nativeTokensPreData === void 0 ? void 0 : nativeTokensPreData.length) > 0) {
      const data = nativeTokensPreData.map(x => {
        const nativeTokenToFind = nativeTokens.find(y => {
          var _a, _b, _c;
          return ((_a = y.wrappedAddress) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = x === null || x === void 0 ? void 0 : x.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase()) && y.network === x.token.networkId;
        });
        return Object.assign(Object.assign({}, x), {
          token: Object.assign(Object.assign({}, x.token), {
            name: nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.tokenName,
            symbol: nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.token,
            address: nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.tokenAddress,
            imageSmallUrl: getNetworkLogo(nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.network),
            imageThumbUrl: getNetworkLogo(nativeTokenToFind === null || nativeTokenToFind === void 0 ? void 0 : nativeTokenToFind.network)
          })
        });
      });
      setNativeTokensData(data);
    }
  }, [nativeTokensPreData]);
  return {
    nativeTokensData,
    nativeTokensDataLoading
  };
}